
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "9f73ab2fd4b908eda7d962e8ad408dd4871546c2",
  "nuxt": {
    "buildId": "ed9c1ddd-13c2-42ce-b350-0c593fa118c8"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
